import RestaurantListPage, { RestaurantListPageProps } from './RestaurantListPage';
import withPresenter from './RestaurantListPage.presenter';
import withInteractor from './RestaurantListPage.interactor';

export type { RestaurantListPageProps };
export default withInteractor(withPresenter(RestaurantListPage));
